import React, { Fragment } from 'react'

import Input from '@Form/Input'
import Button from '@UniformComponents/Button'

const Formula = ({ onChange, formula, name, id, onDelete }) => (
    <div
        style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            padding: '10px',
            border: '1px solid rgb(204, 204, 204)',
            borderRadius: '8px',
        }}
    >
        <Input
            name="name"
            label="Option name"
            defaultValue={name}
            onBlur={({ value, name }) => onChange({ id, value, name })}
        />
        <div>
            <label className="subHeading">
                Formula
            </label>
            <textarea
                name="formula"
                onBlur={(e) => onChange({
                    name: 'formula',
                    id,
                    value: e.target.value,
                })}
                style={{ height: '80px', padding: '10px' }}
            >
                {formula}
            </textarea>
        </div>
        <div
            style={{ textAlign: 'end' }}
        >
            <Button
                label="Delete option"
                icon="fal fa-trash-alt"
                onClick={onDelete}
                cssClass="red"
            />
        </div>
    </div>
)

export default Formula
